class SearchPopupExtended {
  constructor() {
    this.selectors = {
      searchPopup: "[data-search-popup]",
      searchInput: "[data-search-input]",
      recentSearchesSection: "[data-recent-searches]",
      recentSearchesList: "[data-recent-searches-list]",
      clearRecentSearches: "[data-clear-recent-searches]",
      searchForm: "#m-form-search",
      extendedContent: ".m-search-extended-content",
      clearSearchBtn: ".m-search-form--clear",
    };

    this.storageKey = "opulentRecentSearches";
    this.maxRecentSearches = 5;

    this.init();
  }

  init() {
    // Initialize DOM elements
    this.searchPopup = document.querySelector(this.selectors.searchPopup);
    if (!this.searchPopup) return;

    this.searchInput = this.searchPopup.querySelector(
      this.selectors.searchInput
    );
    this.recentSearchesSection = this.searchPopup.querySelector(
      this.selectors.recentSearchesSection
    );
    this.recentSearchesList = this.searchPopup.querySelector(
      this.selectors.recentSearchesList
    );
    this.clearRecentSearchesBtn = this.searchPopup.querySelector(
      this.selectors.clearRecentSearches
    );
    this.searchForm = this.searchPopup.querySelector(this.selectors.searchForm);
    this.extendedContent = this.searchPopup.querySelector(
      this.selectors.extendedContent
    );
    this.clearSearchBtn = this.searchPopup.querySelector(
      this.selectors.clearSearchBtn
    );

    this.setupEventListeners();
    this.loadRecentSearches();
  }

  setupEventListeners() {
    // Clear recent searches
    if (this.clearRecentSearchesBtn) {
      this.clearRecentSearchesBtn.addEventListener(
        "click",
        this.clearRecentSearches.bind(this)
      );
    }

    // Save search query when form is submitted
    if (this.searchForm) {
      this.searchForm.addEventListener(
        "submit",
        this.saveSearchQuery.bind(this)
      );

      // Also save when user presses Enter in the search input
      if (this.searchInput) {
        this.searchInput.addEventListener("keypress", (event) => {
          if (event.key === "Enter") {
            this.saveSearchQuery();
          }
        });

        // Hide extended content when typing
        this.searchInput.addEventListener(
          "input",
          this.handleInputChange.bind(this)
        );
      }
    }

    // Handle individual recent search item removal
    if (this.recentSearchesList) {
      this.recentSearchesList.addEventListener(
        "click",
        this.handleRecentSearchItemClick.bind(this)
      );
    }

    // Check URL for search query on page load
    this.checkURLForSearchQuery();

    // Handle clear search button
    if (this.clearSearchBtn) {
      this.clearSearchBtn.addEventListener(
        "click",
        this.handleClearSearch.bind(this)
      );
    }
  }

  handleInputChange(event) {
    const query = event.target.value.trim();

    if (query.length > 0) {
      // Hide extended content when typing
      if (this.extendedContent) {
        this.extendedContent.style.display = "none";
      }

      // Show clear button if it exists
      if (this.clearSearchBtn) {
        this.clearSearchBtn.style.display = "block";
      }
    } else {
      // Show extended content when input is empty
      if (this.extendedContent) {
        setTimeout(() => {
          this.extendedContent.style.display = "block";
        }, 500);
      }

      // Hide clear button if it exists
      if (this.clearSearchBtn) {
        this.clearSearchBtn.style.display = "none";
      }
    }
  }

  handleClearSearch(event) {
    if (this.searchInput) {
      this.searchInput.value = "";
      this.searchInput.focus();

      // Show extended content when input is cleared
      if (this.extendedContent) {
        this.extendedContent.style.display = "block";
      }

      // Hide clear button
      if (this.clearSearchBtn) {
        this.clearSearchBtn.style.display = "none";
      }
    }
  }

  checkURLForSearchQuery() {
    // Check if current URL contains a search query
    const urlParams = new URLSearchParams(window.location.search);
    const query = urlParams.get("q");

    if (query) {
      this.addRecentSearch(query);
    }
  }

  getRecentSearches() {
    try {
      const searches = localStorage.getItem(this.storageKey);
      return searches ? JSON.parse(searches) : [];
    } catch (error) {
      console.error("Error retrieving recent searches:", error);
      return [];
    }
  }

  saveRecentSearches(searches) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(searches));
    } catch (error) {
      console.error("Error saving recent searches:", error);
    }
  }

  addRecentSearch(query) {
    if (!query) return;

    const searches = this.getRecentSearches();

    // Remove the query if it already exists to avoid duplicates
    const filteredSearches = searches.filter(
      (search) => search.toLowerCase() !== query.toLowerCase()
    );

    // Add the new query at the beginning
    filteredSearches.unshift(query);

    // Limit the number of recent searches
    const limitedSearches = filteredSearches.slice(0, this.maxRecentSearches);

    this.saveRecentSearches(limitedSearches);
    this.renderRecentSearches();
  }

  removeRecentSearch(query) {
    if (!query) return;

    console.log("Removing search query from localStorage:", query);
    try {
      // Get current searches
      const searches = this.getRecentSearches();

      // Filter out the query (case sensitive match)
      const filteredSearches = searches.filter((search) => search !== query);

      // Save back to localStorage
      this.saveRecentSearches(filteredSearches);

      // Update UI
      this.renderRecentSearches();

      console.log("Updated recent searches:", filteredSearches);
    } catch (error) {
      console.error("Error removing recent search:", error);
    }
  }

  clearRecentSearches() {
    try {
      // Clear from localStorage
      localStorage.removeItem(this.storageKey);
      // Also set empty array as fallback
      localStorage.setItem(this.storageKey, JSON.stringify([]));
      // Update UI
      this.renderRecentSearches();
    } catch (error) {
      console.error("Error clearing recent searches:", error);
    }
  }

  renderRecentSearches() {
    if (!this.recentSearchesList) return;

    const searches = this.getRecentSearches();

    // Show/hide the recent searches section based on whether there are any searches
    if (searches.length === 0) {
      this.recentSearchesSection.style.display = "none";
      return;
    } else {
      this.recentSearchesSection.style.display = "block";
    }

    // Clear the list
    this.recentSearchesList.innerHTML = "";

    searches.forEach((query) => {
      // Parent div
      const item = document.createElement("div");
      item.classList.add("m-search-recent-item");
      item.setAttribute("data-query", query);

      // ✅ New <a> with just text (no icon)
      const link = document.createElement("a");
      link.href = `/search?q=${encodeURIComponent(query)}`;
      link.style.display = "flex";
      link.style.gap = "5px";
      link.style.alignItems = "center";

      // ⬇️ SVG icon
      const icon = document.createElement("span");
      icon.innerHTML = `
        <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="m8.444 4.932-2-2 2-2M1.965 8.432a5.982 5.982 0 0 0 .169 2M3.348 5.075a5.979 5.979 0 0 0-.82 1.27M3.363 12.806a5.99 5.99 0 0 0 1.533 1.295" stroke="#000" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M7.444 14.911a6 6 0 1 0 .5-11.98h-1.5" stroke="#000" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      `;
      icon.classList.add("search-icon");
      link.appendChild(icon);

      const queryText = document.createElement("span");
      queryText.textContent = query;
      link.appendChild(queryText);

      item.appendChild(link); // <a> inside <div>

      // ❌ Remove button stays outside <a>
      const removeBtn = document.createElement("button");
      removeBtn.classList.add("remove-btn");
      removeBtn.innerHTML = `
        <svg width="11" height="11" viewBox="0 0 22 22" fill="none" class="drawer__close" xmlns="http://www.w3.org/2000/svg" aria-label="Close">
          <path d="M 1.003 1.003 L 21.111 20.959 M 21.111 1.003 L 1.003 20.959" fill="#000" stroke="#000" stroke-linecap="round" stroke-width="2"></path>
        </svg>
      `;
      removeBtn.setAttribute("data-remove", query);
      removeBtn.setAttribute("type", "button");
      removeBtn.setAttribute(
        "aria-label",
        `Remove ${query} from recent searches`
      );

      item.appendChild(removeBtn); // button inside main div

      this.recentSearchesList.appendChild(item);
    });
  }

  handleRecentSearchItemClick(event) {
    // Check if the remove button or any of its children (like SVG or path) was clicked
    const removeBtn = event.target.closest("[data-remove]");
    if (removeBtn) {
      event.preventDefault();
      event.stopPropagation();
      const query = removeBtn.getAttribute("data-remove");
      this.removeRecentSearch(query);
    } else if (
      event.target.tagName === "path" ||
      event.target.tagName === "svg"
    ) {
      // Handle case where SVG or path was clicked directly
      const button = event.target.closest("button");
      if (button && button.hasAttribute("data-remove")) {
        event.preventDefault();
        event.stopPropagation();
        const query = button.getAttribute("data-remove");
        this.removeRecentSearch(query);
      }
    }
  }

  saveSearchQuery(event) {
    if (event) {
      event.preventDefault();
    }

    const query = this.searchInput.value.trim();
    if (query) {
      this.addRecentSearch(query);

      // If this was triggered by an event and not programmatically, submit the form
      if (event) {
        event.target.submit();
      }
    }
  }

  loadRecentSearches() {
    // Render the recent searches on initialization
    this.renderRecentSearches();

    // Check if search input has value on page load
    if (this.searchInput && this.searchInput.value.trim().length > 0) {
      if (this.extendedContent) {
        this.extendedContent.style.display = "none";
      }

      if (this.clearSearchBtn) {
        this.clearSearchBtn.style.display = "block";
      }
    } else {
      if (this.extendedContent) {
        this.extendedContent.style.display = "block";
      }

      if (this.clearSearchBtn) {
        this.clearSearchBtn.style.display = "none";
      }
    }
  }
}

// Initialize the extended search popup functionality when the DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  window.OpulentTheme = window.OpulentTheme || {};
  window.OpulentTheme.SearchPopupExtended = new SearchPopupExtended();
});
